import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';

export class DialogDoneConfirmation {

    constructor(
        public orderId: string,
        public symbol: string,
        public descriptionStock: string,
        public amount: number,
        public price: number,
        public marketType: OrderMarketTypeEnum,
        public side: OrderSideEnum,
        public stressFactor: number,
        public quoteFactor: number,
        public lossPrice: number,
        public isDayTrade: boolean,
        public isPtax: boolean,
        public brokerageFactor: number,
        public defaultStressValue?: number,
        public originType?: number,
        public marketOpen?: boolean,
        public marketoOpeningTime?: string,
        public originAction?: string,
    ) { }
}
